import { Button as AntButton } from "antd";
import PropTypes from "prop-types";

const ALIGNMENTS = ["left", "center", "right"];

const TYPES = [
  "default",
  "primary",
  "secondary",
  "primary-light",
  "primary-outlined",
  "danger-light",
  "gray-light",
  "transparent",
];

const Button = ({
  type,
  alignment,
  children,
  size,
  width,
  className,
  icon,
  ...rest
}) => (
  <div
    className={`miltis__button ${alignment} ${className || ""}`}
    style={{ width }}
  >
    <AntButton
      className={[type, size, icon ? "has-icon" : ""].filter(Boolean).join(" ")}
      {...rest}
      icon={icon}
    >
      {children}
    </AntButton>
  </div>
);

Button.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENTS),
  type: PropTypes.oneOf(TYPES),
};

Button.defaultProps = {
  alignment: "left",
  type: "default",
};

export default Button;
